// extracted by mini-css-extract-plugin
export default {"banners":"GlobalBanners_banners__2HQ3R","banner":"GlobalBanners_banner__a2aJx","showBackground":"GlobalBanners_showBackground__U8rZZ"};